type Origin = 'cn' | 'eu';

type LegalLinkId = 'legalNotice' | 'privacyNotice' | 'publisher';

interface LegalLinkObj {
  links: {
    id: LegalLinkId;
    url: string;
  }[];
  origin: Origin;
}

const legalLinks: LegalLinkObj[] = [
  {
    links: [
      {
        id: 'legalNotice',
        url: 'https://www.zeiss.com/corporate/en/legal-information/legal-notice-and-general-terms-and-conditions.html?vaURL=www.zeiss.com/legal-notice',
      },
      {
        id: 'privacyNotice',
        url: 'https://zeiss.com/dataprotection',
      },
      {
        id: 'publisher',
        url: 'https://www.zeiss.de/corporate/rechtliches/impressum.html?vaURL=www.zeiss.com/publisher',
      },
    ],
    origin: 'eu',
  },
  {
    links: [
      {
        id: 'legalNotice',
        url: 'https://www.zeiss.com.cn/corporate/en/legal-information/legal-notice.html',
      },
      {
        id: 'privacyNotice',
        url: 'https://zeiss.com/dataprotection',
      },
      {
        id: 'publisher',
        url: 'https://www.zeiss.com.cn/corporate/en/legal-information/publisher.html',
      },
    ],
    origin: 'cn',
  },
];

export const getOriginLegalLink = (linkId: LegalLinkId) => {
  const currentOrigin = window.location.origin;

  let normalizedOrigin: Origin = 'eu';

  if (currentOrigin.endsWith('cn')) {
    normalizedOrigin = 'cn';
  }

  const requestedLink = legalLinks
    .find(({ origin }) => origin === normalizedOrigin)
    ?.links.find(({ id }) => id === linkId)?.url;

  return requestedLink ?? '';
};
